import React from 'react';
import c from '../w.js';

const IconMinusCircleFilled = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM8 13H16V11H8V13Z"
      }
    )
  )
);

export { IconMinusCircleFilled };
